<template>
    <FormModel
        :action="submit" :labelCol="{span:4}" :model="config.startup"
        :rules="rules" :wrapperCol="{span: 20}" style="width: 560px;" v-on="$listeners">
        <a-alert :show-icon="true" type="warning">
            <div slot="message">
                <div>* 启动背景请上传 JPG 或 PNG 格式图片，建议尺寸 1080px * 1920px</div>
                <div>* 根据手机屏适配展示，由于手机屏尺寸大小不一，建议将核心内容放在图片中间</div>
            </div>
        </a-alert>
        <a-form-model-item label="是否启用" style="margin-top: 20px;">
            <a-radio-group v-model="config.startup.enable">
                <a-radio :value="true">开启</a-radio>
                <a-radio :value="false">停用</a-radio>
            </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="启动背景">
            <ImageUpload :height="300" :width="168" v-model="config.startup.bg_image"/>
        </a-form-model-item>
        <a-form-model-item label="倒计时长">
            <a-input-number :min="1" v-model="config.startup.interval"/>
            <span style="padding-left: 10px;">秒后自动关闭启动页，进入直播页</span>
        </a-form-model-item>
        <a-form-model-item label="按钮文案">
            <a-input v-model="config.startup.btn_text"/>
        </a-form-model-item>
    </FormModel>
</template>

<script>
    import func from "../../../../utils/func";
    import cache from "../../../../utils/cache";
    import FormModel from "../../../../comps/FormModel";
    import ImageUpload from "../../../../comps/ImageUpload";

    export default {
        name: "Startup",
        props: {album: Object},
        components: {FormModel, ImageUpload},
        data() {
            return {
                config: {
                    startup: {
                        enable: true,
                        bg_image: "",
                        btn_text: "进入相册",
                        interval: 3,
                    }
                },
                rules: {}
            }
        },
        mounted() {
            this.config = func.copyObject(this.album.config);
        },
        methods: {
            submit() {
                return cache.v1.album.setConfig(this.album.id, this.config)
                    .then(() => this.album.config = this.config);
            }
        }
    }
</script>
